import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { Exams } from './exams';

const routes: Routes = [
  {
    path: 'exams',
    component: Exams
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ExamsRoutingModule {}
